var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col items-center justify-center p-8",class:{ 'absolute-loader': _vm.absolute }},[_c('spinner',{staticClass:"opacity-60 dark:opacity-70",attrs:{"size":"large"}}),_vm._v(" "),_c('div',{staticClass:"txt-muted mt-2 block text-center text-sm"},[_vm._v(_vm._s(_vm.message))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }